import PropTypes from 'prop-types';
import React from 'react';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';

export default function ContentMenu(props) {
    const { content, isInstructor, push } = props;
    const onSelection = value => {
        switch (value) {
            case 'delete':
                props.onDelete();
                break;
            case 'sharing':
                push(`content-${content.id}/address/${0}/sharing`);
                break;
            default:
                break;
        }
    };

    const items = [];

    if (isInstructor && !content.is_courseload_administered) {
        items.push(
            <MenuItem
                aria-label="Delete"
                className="react-dropdown-menu-item-wrapper react-dropdown-menu-item"
                key="delete"
                tag="li"
                value="delete"
            >
                <i className="cl-icon cl-icon-trash-o" />
                Delete
            </MenuItem>
        );
    }

    return items.length ? (
        <div className="react-dropdown-wrapper">
            <Wrapper className="react-dropdown" onSelection={onSelection}>
                <Button className="react-dropdown-button">
                    <span aria-hidden>...</span>
                    <span className="aural">Options for {content.title}</span>
                </Button>
                <Menu className="react-dropdown-menu">
                    <ul>{items}</ul>
                </Menu>
            </Wrapper>
        </div>
    ) : null;
}
ContentMenu.propTypes = {
    isInstructor: PropTypes.bool.isRequired,
    content: PropTypes.shape({
        id: PropTypes.number.isRequired,
        is_courseload_administered: PropTypes.bool.isRequired,
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
    analyticsMode: PropTypes.oneOf(['term', 'section']).isRequired,
    section: PropTypes.shape({
        id: PropTypes.number.isRequired,
        term_id: PropTypes.number.isRequired,
    }).isRequired,
    isBlocked: PropTypes.bool.isRequired,
    hideSharingQA: PropTypes.bool.isRequired,
    push: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/content_menu.ui.jsx